
        var result = require("!!../../../../node_modules/css-loader/index.js!./roles.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/roles/roles.component.css
// module id = 732
// module chunks = 0